import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

export const Box = styled.div`
  position: relative;
  box-sizing: border-box;
  background: #10151a;
  border-radius: 10px;
  overflow: hidden;
`;

export const Spinner = styled.div`
  position: absolute;
  inset: 0;
  z-index: 4;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #10151a;
  border-radius: 10px;

  &::after {
    content: '';
    width: 34px;
    height: 34px;
    border-radius: 50%;
    border: 3px solid #2c353d;
    border-top-color: #47b972;
    animation: ${spin} 0.9s linear infinite;
  }
`;

export const TwoVideosPlace = styled.div`
  display: block;
  position: relative;
`;
